"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("./actions");
var fn_1 = require("./fn");
var useFilterSelector_1 = require("./useFilterSelector");
var reducer = function (state, action) {
    switch (action.type) {
        case actions_1.FilterSelectorActionTypes.SELECT: {
            var _a = action.payload, selectedIndex = _a.selectedIndex, options = _a.options, getSelectedOptionFn = _a.getSelectedOptionFn;
            var selected = options[selectedIndex];
            if (selected) {
                if (getSelectedOptionFn) {
                    getSelectedOptionFn(selected);
                }
                return (__assign(__assign({}, state), { selectedIndex: selectedIndex, selectedText: selected.text, isDisplaySelects: false }));
            }
            return state;
        }
        case actions_1.FilterSelectorActionTypes.RESET_SELECTED:
            return (__assign(__assign({}, state), { filteredOptions: action.payload.options, selectedText: action.payload.defaultSelectedText, filterInput: useFilterSelector_1.initFilterSelectorContainerState.filterInput, selectedIndex: useFilterSelector_1.initFilterSelectorContainerState.selectedIndex }));
        case actions_1.FilterSelectorActionTypes.FILTER: {
            var _b = action.payload, filterInput = _b.filterInput, options = _b.options;
            var filteredOptions = fn_1.filterRoutesByValue(filterInput, options);
            return (__assign(__assign({}, state), { filterInput: filterInput,
                filteredOptions: filteredOptions }));
        }
        case actions_1.FilterSelectorActionTypes.TOGGLE_DISPLAY_SELECTS:
            return (__assign(__assign({}, state), { isDisplaySelects: !state.isDisplaySelects }));
        case actions_1.FilterSelectorActionTypes.SET_STATE:
            return (__assign(__assign({}, state), action.payload));
    }
};
exports.default = reducer;
